module.exports = __webpack_public_path__ + "img/csl-behring-logo.ef1d5d9b.png";